const staffPayment = "StaffPaymentTypes";
export const StaffPaymentTypes = {
  SHOW_STAFF: `${staffPayment} SHOW_STAFF`,
  SHOW_STAFF_PAYMENT: "SHOW_STAFF_PAYMENT",
  ADD_STAFF_PAYMENT: "ADD_STAFF_PAYMENT",
  UPDATE_STAFF_PAYMENT: "UPDATE_STAFF_PAYMENT",
  DELETE_STAFF_PAYMENT: "DELETE_STAFF_PAYMENT",
  SHOW_ACCOUNT: `${staffPayment} SHOW_ACCOUNT`,
};
